import { useEffect, useState } from "react";
import axios from "axios";
import { Sprout } from "lucide-react";
import { useTheme } from "./theme";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cachedConfig = null;
const listeners = new Set();

export function refreshSiteConfig() {
  return axios.get(`${API}/site/config`).then((r) => {
    cachedConfig = r.data || {};
    listeners.forEach((fn) => fn(cachedConfig));
    return cachedConfig;
  }).catch(() => (cachedConfig = {}));
}

export function useSiteConfig() {
  const [cfg, setCfg] = useState(cachedConfig);
  useEffect(() => {
    listeners.add(setCfg);
    if (!cachedConfig) refreshSiteConfig();
    return () => { listeners.delete(setCfg); };
  }, []);
  return cfg || {};
}

export function BrandLogo({ size = 36, rounded = "rounded-md", className = "", variant }) {
  const cfg = useSiteConfig();
  const { theme } = useTheme();
  const chosen = variant || (theme === "dark" ? "dark" : "light");
  // If chosen variant is missing, fall back to the other one
  const dark = cfg?.logo_url_dark;
  const light = cfg?.logo_url;
  const url = chosen === "dark" ? (dark || light) : (light || dark);
  const logo = url ? `${process.env.REACT_APP_BACKEND_URL}${url}` : null;
  const base = `${rounded} bg-primary text-primary-foreground flex items-center justify-center overflow-hidden ${className}`;
  const style = { width: size, height: size };
  if (logo) {
    return (
      <div className={base} style={style}>
        <img src={logo} alt="Logo" className="w-full h-full object-cover" />
      </div>
    );
  }
  return (
    <div className={base} style={style}>
      <Sprout size={Math.round(size * 0.5)} />
    </div>
  );
}
